import queryString from 'query-string';

const qs = {
  parse: (o) => queryString.parse(o, { arrayFormat: 'bracket' }),
  stringify: (o) => queryString.stringify(o, { arrayFormat: 'bracket' }),
};

export default qs;
